import React, { createContext, useContext } from 'react';
import { string, number, node, shape } from 'prop-types';

const ChartContext = createContext();
export const useChartDimensions = () => useContext(ChartContext);

const Chart = React.forwardRef(({ dimensions, children, name }, ref) => (
  <ChartContext.Provider value={dimensions}>
    <svg
      ref={ref}
      data-testid={`svg-${name}`}
      width={dimensions.width}
      height={dimensions.height}
      xmlns="http://www.w3.org/2000/svg"
      style={{ overflow: 'visible' }}
    >
      <g
        transform={`translate(${dimensions.marginLeft}, ${dimensions.marginTop})`}
      >
        {children}
      </g>
    </svg>
  </ChartContext.Provider>
));

Chart.propTypes = {
  dimensions: shape({
    height: number,
    width: number,
    marginTop: number,
    marginRight: number,
    marginBottom: number,
    marginLeft: number,
  }),
  children: node.isRequired,
  name: string.isRequired,
};

Chart.defaultProps = {
  dimensions: {
    height: 500,
    width: 500,
    marginTop: 16,
    marginRight: 16,
    marginBottom: 16,
    marginLeft: 16,
  },
};

export default Chart;
